import { SWFParser, StageScaleMode, StageAlign, MovieClipSoundStream } from "@awayfl/swf-loader";
import { AVMAwayStage, AVM1SceneGraphFactory, AVM1Globals, TraceLevel, AVM1ContextImpl, SecurityDomain, LoaderInfo } from "@awayfl/avm1";
import { AssetLibrary, AudioManager, AssetEvent, LoaderEvent, URLLoaderEvent, URLRequest, ColorUtils } from "@awayjs/core";
import { MovieClip, Font, DefaultFontManager, FrameScriptManager } from "@awayjs/scene";
var PlayerAVM1 = /** @class */ (function () {
    function PlayerAVM1() {
        var _this = this;
        this._skipFrames = 0;
        this.showAdOnFrame = -1;
        this._fontsLoadedCallback = null;
        // create the AwayStage for AVM1
        this._stage = new AVMAwayStage(window.innerWidth / 2, window.innerHeight / 2, 0xffffff, 24, null, window.innerWidth / 2, window.innerHeight / 2, false);
        this._stage.scene.mouseManager._stage = this._stage;
        this._stage.rendererStageContainer.style.visibility = "hidden";
        var loaderInfo = new LoaderInfo();
        this._avm1SceneGraphFactory = new AVM1SceneGraphFactory(new AVM1ContextImpl(loaderInfo));
        this._avm1SceneGraphFactory.avm1Context.sec = new SecurityDomain();
        this._avm1SceneGraphFactory.avm1Context.setStage(this._stage, document);
        AVM1Globals.tracelevel = TraceLevel.ALL;
        AVM1Globals._scenegraphFactory = this._avm1SceneGraphFactory;
        AssetLibrary.enableParser(SWFParser);
        this._onAssetCompleteDelegate = function (event) { return _this._onAssetComplete(event); };
        this._onLoadCompleteDelegate = function (event) { return _this.onLoadComplete(event); };
        this._onLoadErrorDelegate = function (event) { return _this._onLoadError(event); };
        this._onAssetCompleteFontsDelegate = function (event) { return _this._onAssetFontsComplete(event); };
        this._onLoadCompleteFontsDelegate = function (event) { return _this.onLoadFontsComplete(event); };
        this._onLoadErrorFontsDelegate = function (event) { return _this._onLoadFontsError(event); };
        window.addEventListener("resize", function (e) { return _this._stage.resizeCallback(e); });
    }
    PlayerAVM1.prototype.registerCustomExitFrameCallback = function (callback) {
        return this._stage.registerCustomExitFrameCallback(callback);
    };
    PlayerAVM1.prototype.screenshot = function (callback) {
        return this._stage.screenshot(callback);
    };
    Object.defineProperty(PlayerAVM1.prototype, "avm1SceneGraphFactory", {
        get: function () {
            return this._avm1SceneGraphFactory;
        },
        enumerable: true,
        configurable: true
    });
    PlayerAVM1.prototype.preloadFonts = function (url, onFinished) {
        this._fontsLoadedCallback = onFinished;
        if (!this._parser) {
            this._parser = new SWFParser(this._avm1SceneGraphFactory);
            this._parser._iFileName = url;
        }
        AssetLibrary.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteFontsDelegate);
        AssetLibrary.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoadCompleteFontsDelegate);
        AssetLibrary.addEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorFontsDelegate);
        AssetLibrary.load(new URLRequest(url), null, null, this._parser);
    };
    PlayerAVM1.prototype.playSWF = function (buffer, url, skipFramesOnScene, skipFramesCallback) {
        if (skipFramesOnScene === void 0) { skipFramesOnScene = 0; }
        if (skipFramesCallback === void 0) { skipFramesCallback = null; }
        this._skipFrames = skipFramesOnScene;
        this._skipFramesCallback = skipFramesCallback;
        AudioManager.setVolume(1);
        this._avm1SceneGraphFactory.avm1Context.executionProhibited = false;
        if (this._parser) {
            this._parser.dispose();
        }
        this._parser = new SWFParser(this._avm1SceneGraphFactory);
        this._parser._iFileName = url;
        AssetLibrary.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoadCompleteDelegate);
        AssetLibrary.addEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        AssetLibrary.loadData(buffer, null, null, this._parser);
    };
    PlayerAVM1.prototype._onLoadFontsError = function (event) {
        console.log("error preloading fonts", event);
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteFontsDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoadCompleteFontsDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorFontsDelegate);
    };
    PlayerAVM1.prototype._onAssetFontsComplete = function (event) {
        var asset = event.asset;
        if (asset.isAsset(Font)) {
            DefaultFontManager.deviceFont = asset;
            console.log("font loaded", asset);
        }
    };
    PlayerAVM1.prototype.onLoadFontsComplete = function (event) {
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteFontsDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoadCompleteFontsDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorFontsDelegate);
        if (this._fontsLoadedCallback) {
            this._fontsLoadedCallback();
        }
    };
    PlayerAVM1.prototype._onLoadError = function (event) {
    };
    PlayerAVM1.prototype._onAssetComplete = function (event) {
        var asset = event.asset;
        if (asset.isAsset(MovieClip)) {
            if (asset.isAVMScene) {
                if (this._stage)
                    this._stage.getLayer(0).addChild(asset);
                asset.adapter.initAdapter();
            }
        }
    };
    PlayerAVM1.prototype.onLoadComplete = function (event) {
        var _this = this;
        //console.log("loaded a SWFFile", this._parser.swfFile);
        console.debug("FP-VERSION", this._parser.swfFile.fpVersion);
        this._stage.color = ColorUtils.f32_RGBA_To_f32_ARGB(this._parser.swfFile.backgroundColor);
        this._stage.frameRate = this._parser.swfFile.frameRate;
        MovieClipSoundStream.frameRate = this._parser.swfFile.frameRate;
        this._stage.stageWidth = this._parser.swfFile.bounds.width / 20;
        this._stage.stageHeight = this._parser.swfFile.bounds.height / 20;
        this._avm1SceneGraphFactory.avm1Context.swfVersion = this._parser.swfFile.swfVersion;
        this._stage.scaleMode = StageScaleMode.SHOW_ALL;
        this._stage.align = StageAlign.TOP;
        this._stage && this._stage.resizeCallback();
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoadCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        if (window["hidePokiProgressBar"])
            window["hidePokiProgressBar"]();
        if (this._skipFrames > 0) {
            FrameScriptManager.execute_queue();
            if (this._skipFramesCallback) {
                AudioManager.setVolume(0);
                this._skipFramesCallback(function () {
                    AudioManager.setVolume(1);
                    _this._stage.getLayer(0).getChildAt(0).currentFrameIndex = _this._skipFrames;
                    _this._stage.getLayer(0).getChildAt(0).play();
                });
            }
            else {
                this._stage.getLayer(0).getChildAt(0).currentFrameIndex = this._skipFrames;
                this._stage.getLayer(0).getChildAt(0).play();
            }
        }
        this._stage.rendererStageContainer.style.visibility = "visible";
    };
    return PlayerAVM1;
}());
export { PlayerAVM1 };
